export const isEnabledDimensionInput = (element: HTMLInputElement | HTMLSelectElement): boolean => {
    return element.dataset.dimensionEnabled === 'true';
};
